<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Gyan Manthan </h1>
                </div>
            </div>
        </div>
    </div>
</section>
<ul class="breadcrumb">
    <li><a href="#">Event</a></li>
    <li><i class="fa fa-angle-double-right"></i></li>
    <li>Gyan Manthan </li>
</ul>

<section class="section-lg chair-msg">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="text-justify" >
                    <p>G H Raisoni College of Commerce, Science and Technology Organized GyanManthan Management Fest -
                        2024 from 20th to 22nd Feb 2024 for the students of BBA and B.Com (Hons) Management Fest was
                        held with the objective of encouraging the students to hone their Managerial skills. There were
                        different events organized under the Marketing, Human Resources, Entrepreneurship Development
                        and Finance fields to bring out the best in participants.</p>
                    <p>Participants in the <strong>ED Forum "Udyami" competition</strong> had to go through two tiers of
                        elimination
                        rounds, the first of which was 'The Business Jargons Word Power Competition' on February 10,
                        2024, and the second of which was "Decoding the Journey of the Entrepreneur." Participants who
                        completed the two tiers were eligible for the Final round of the "Udyami" Competition, which
                        took place on February 21, 2024, with nine teams participating. Seven teams advanced to the
                        Final Round, where they decoded the business journeys of Nagpur entrepreneurs, how they began
                        their ventures, and how they dealt with the falling challenge, which called into doubt their
                        survival and existence in business. In the final phase, seven teams were examined and grilled
                        rigorously by external expert Mr. Akshat Soni, Director, Bizleap, Nagpur, to ensure their
                        knowledge and conceptual understanding of critical business components.</p>
                    <p><strong>Revamp conducted under Marketing Forum</strong> in the elimination round activity In
                        charge gave the
                        company to students and they had to make a presentation on the analysis of discontinued
                        company's product. Six teams qualified for the final round; they presented advertisements on the
                        allotted company Team assessed based on creativity and analysis of the company.</p>
                    <p><strong>HR Forum under Gyanmanthan- 2024</strong> had organized various activities for the
                        students of BBA. The
                        activities focused on creating an interest and awareness among the students for HR and its
                        importance. The HR Forum had organized two rounds for the participants, the Eliminations and the
                        Finals.GD was taken as an elimination round & Role Play activity as the final round for the
                        qualifiers.</p>
                    <p><strong>Under the Finance Forum,</strong> the elimination round was of finance quiz. Which
                        consisted of three
                        rounds of buzzer rounds, decoding the logos and matching the following? The Final round was of
                        Virtual Trading competition in which the students had to immerse themselves in the stock market
                        with the Virtual money of one crore. The judge of the competition was CA Deepak Motwani.

                    </p>
                    <p>On the final day, there was a Prize distribution ceremony in which Mr.Karamjit Singh was the
                        Chief Guest. He shared his experiences and motivated the students. Dr.Pankaj Pethe, the incharge
                        of activity along with other team members made this event a successful one. Director Dr. Aarti
                        Deshpande and Principal Dr. Jasvinder Kaur motivated and supported the entire team to make this
                        activity a grand success.

                    </p>
                </div>
            </div>
        </div>
        <div class="row mb-20">
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/events/gyan-manthan-1.jpg" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/events/gyan-manthan-1.jpg" alt="Events | Ghrcacsn"
                            title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/events/gyan-manthan-2.jpg" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/events/gyan-manthan-2.jpg" alt="Events | Ghrcacsn"
                            title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="assets/images/events/gyan-manthan.jpg" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="assets/images/events/gyan-manthan.jpg" alt="Events | Ghrcacsn"
                            title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>

        </div>
    </div>
</section>